export class userManagementUrl {
    ADD_USER_URL = "suite/user/";
    GET_ALL_USERS_URL= "suite/user/all[?Name][&Email][&PageSize][&PageNumber][&SortBy][&SortOrder]";   
    GET_ALL_USER_GROUPS_URL= "suite/user/user-group/all-groups-with-role"; 
    DELETE_USER_URL= "suite/user/{userId}";
    EDIT_USER_URL= "suite/user/";
}